'use strict';

// One bounded polling stream for the legacy role pages. No raw model subscriptions.
function createLegacyMonitor({ snapshot, detail, apply, onError, visible = () => true,
  schedule = setInterval, unschedule = clearInterval }) {
  let context;
  let revision = 0;
  let pending;
  let timer;

  async function refresh() {
    if (!context || pending) return pending;
    const selected = context;
    const version = revision;
    const current = () => version === revision;
    const work = (async () => {
      let data = await snapshot(selected.role, selected.eventId, selected.disciplineId);
      if (!current()) return;
      if (selected.sessionId && !selected.disciplineId) {
        const session = data.sessions.find(item => item.id === selected.sessionId);
        if (!session) throw new Error('Session not found in this event');
        selected.disciplineId = session.eventDisciplineId;
        data = await snapshot(selected.role, selected.eventId, selected.disciplineId);
        if (!current()) return;
      }
      let exercise;
      const panel = selected.role === 'supervisor' && selected.panelId
        ? (data.panels || []).find(item => item.id === selected.panelId && item.sessionId === selected.sessionId)
        : undefined;
      if (panel && panel.exerciseId) {
        exercise = await detail(selected.eventId, panel.exerciseId);
        if (!current()) return;
      }
      apply(data, selected, exercise && { ...exercise, panelId: panel.id, pass: panel.activePass });
      return data;
    })();
    pending = work;
    try { return await work; }
    finally { if (pending === work) pending = undefined; }
  }

  function stop() {
    revision++;
    context = undefined;
    pending = undefined;
    if (timer !== undefined) unschedule(timer);
    timer = undefined;
  }

  async function open(selected) {
    stop();
    context = { ...selected };
    return refresh();
  }

  function start() {
    if (timer !== undefined || !context) return;
    timer = schedule(() => {
      if (visible()) refresh().catch(onError);
    }, 2000);
  }

  return { open, refresh, start, stop };
}

function legacyRoleContext(route) {
  const prefix = /^\/(cis|supervisor)\//.exec(route.path);
  if (!prefix || !route.params.eventId) return undefined;
  return {
    role: prefix[1] === 'cis' ? 'observer' : 'supervisor',
    eventId: route.params.eventId,
    sessionId: route.params.sessionId,
    panelId: route.params.panelId,
  };
}

module.exports = { createLegacyMonitor, legacyRoleContext };
